<template>
  <v-app>
    <v-main>
      <router-view @show-alert="showAlert"/>
    </v-main>
    <alert-snackbar ref="alert"/>
  </v-app>
</template>

<script>
import AlertSnackbar from './components/shared/AlertSnackbar.vue';

export default {
  name: 'App',
  components: {
    AlertSnackbar
  },
  methods: {
    showAlert(options) {
      this.$refs.alert.showAlert(options);
    }
  }
};
</script>
